import { useNavigate, Link, useLocation } from "react-router-dom";
import { Plus, LogOut, Lock, Map } from "lucide-react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, profile } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("Logged out");
      navigate("/login");
    } catch {
      toast.error("Logout failed");
    }
  };

  const initial = (profile?.name || profile?.display_name || user?.email || "T")
    .charAt(0)
    .toUpperCase();

  const isHome = location.pathname === "/";
  const isMyTrips = location.pathname === "/my-trips";

  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-slate-100" data-testid="navbar">
      <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 active:scale-95 transition-transform">
          <div className="w-8 h-8 bg-indigo-600 rounded-xl flex items-center justify-center shadow-sm shadow-indigo-600/30">
            <Lock className="w-4 h-4 text-white" />
          </div>
          <span className="font-bold text-slate-900 tracking-tight">TripLatch</span>
        </Link>

        <div className="flex items-center gap-2">
          {user && !isMyTrips && (
            <Link
              to="/my-trips"
              data-testid="nav-my-trips"
              className="hidden sm:flex h-9 px-3 rounded-full text-sm font-medium text-slate-700 hover:bg-slate-100 items-center gap-1.5"
            >
              <Map className="w-4 h-4" />
              My Trips
            </Link>
          )}

          {user && !isHome && (
            <button
              data-testid="nav-create-trip"
              onClick={() => navigate("/create")}
              className="h-9 px-3 rounded-full bg-indigo-600 text-white text-sm font-semibold flex items-center gap-1.5 hover:bg-indigo-700 active:scale-95 transition-all"
            >
              <Plus className="w-4 h-4" />
              New Trip
            </button>
          )}

          {user ? (
            <button
              data-testid="nav-avatar"
              onClick={handleLogout}
              title="Logout"
              className="w-9 h-9 rounded-full bg-indigo-100 hover:bg-indigo-200 text-indigo-700 font-semibold flex items-center justify-center active:scale-95 transition-all overflow-hidden"
            >
              {profile?.photo_url ? (
                <img src={profile.photo_url} alt="" className="w-full h-full object-cover" />
              ) : (
                <span className="text-sm">{initial}</span>
              )}
            </button>
          ) : (
            <button
              data-testid="nav-login"
              onClick={() => navigate("/login")}
              className="h-9 px-4 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 active:scale-95 transition-all"
            >
              Login
            </button>
          )}
        </div>
      </div>
      {user && (
        <button
          data-testid="nav-logout-mobile"
          onClick={handleLogout}
          className="sr-only"
          aria-label="Logout"
        >
          <LogOut className="w-4 h-4" />
        </button>
      )}
    </header>
  );
}
